import type { BffApiClient } from "@/app/api-client"
import type { BlockchainFilter } from "@/app/blockchains/filters/blockchain-filters-scope"

interface QueryInput {
  blockchain: BlockchainFilter
}

export function getFeaturedCollectionsQueryParams(
  apiClient: BffApiClient,
  queryInput: QueryInput,
) {
  return {
    queryKey: ["collections", "featured", queryInput],
    queryFn: async () => {
      const response = await apiClient.api.collections.featured.$get(
        { query: { blockchain: queryInput.blockchain } },
        { init: { next: { revalidate: 10 } } },
      )

      if (!response.ok) throw await response.json()

      const result = await response.json()

      return result
    },
  }
}
